module.exports = __webpack_public_path__ + "static/img/logo.4676a51.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/channel/img/logo.png
// module id = PnuG
// module chunks = 1